import { Skeleton, TableCell, TableRow } from "@mui/material"
import React, { FC } from "react"

type TableRowsLoaderProps = {
  totalRows: number
  cellsPerRow: number
}

const View: FC<TableRowsLoaderProps> = ({ totalRows, cellsPerRow }) => {
  return (
    <>
      {Array.from({ length: totalRows }).map((_, index) => (
        <TableRow key={index}>
          {Array.from({ length: cellsPerRow }).map((_, idx) => (
            <TableCell key={idx} scope='row'>
              <Skeleton animation='wave' variant='text' />
            </TableCell>
          ))}
        </TableRow>
      ))}
    </>
  )
}

export default View
